<template>
  <div class="wrapper">
    <div
      style="backgroundImage: url(./img/wixbackground.png); background-size: cover; min-height: 93vh"
    >
      <NavbarBlack_fr />

      <div class="md-layout">
        <div
          class="md-layout-item md-size-100 md-small-100"
          style="height: 220px"
        />
        <div class="md-layout-item md-size-30 md-small-hide"></div>
        <div
          class="md-layout-item md-size-40 md-small-size-100"
          style="text-align: center; background-color: white; padding-left: 60px; padding-right: 70px;"
        >
          <div style="text-align: center">
            <div
              slot="title"
              class="title"
              style="font-family: 'Roboto'; color:black;font-size: xxx-large;padding-top: 30px;"
            >
              {{ $t("S'enregistrer") }}
            </div>
            <h4
              slot="title"
              class="title"
              style="font-family: 'Roboto'; color:darkslateblue"
            >
              Bienvenue chez RPAS WILCO
            </h4>
          </div>
          <md-field
            class="md-form-group"
            slot="inputs"
            :class="[
              { 'md-valid': !errors.has('firstname') && touched.firstname },
              { 'md-error': errors.has('firstname') }
            ]"
          >
            <md-icon>face</md-icon>
            <label>{{ $t("Prénom") }}</label>
            <md-input
              name="firstname"
              data-vv-name="firstname"
              v-model="firstname"
              required
              v-validate="'required|min:2'"
              type="text"
            ></md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="errors.has('firstname')"
                >close</md-icon
              >
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon
                class="success"
                v-show="!errors.has('firstname') && touched.firstname"
                >done</md-icon
              >
            </slide-y-down-transition>
          </md-field>
          <md-field
            class="md-form-group"
            slot="inputs"
            :class="[
              { 'md-valid': !errors.has('lastname') && touched.lastname },
              { 'md-error': errors.has('lastname') }
            ]"
          >
            <md-icon>face</md-icon>
            <label>{{ $t("Nom de famille") }}</label>
            <md-input
              name="lastname"
              data-vv-name="lastname"
              v-model="lastname"
              required
              v-validate="'required|min:2'"
              type="text"
            ></md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="errors.has('lastname')"
                >close</md-icon
              >
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon
                class="success"
                v-show="!errors.has('lastname') && touched.lastname"
                >done</md-icon
              >
            </slide-y-down-transition>
          </md-field>
          <md-field
            class="md-form-group"
            slot="inputs"
            :class="[
              { 'md-valid': !errors.has('email') && touched.email },
              { 'md-error': errors.has('email') }
            ]"
          >
            <md-icon>email</md-icon>
            <label>{{ $t("Adresse courriel") }}</label>
            <md-input
              name="email"
              data-vv-name="email"
              v-model="email"
              required
              v-validate="'required|email'"
              type="email"
            ></md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="errors.has('email')"
                >close</md-icon
              >
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon
                class="success"
                v-show="!errors.has('email') && touched.email"
                >done</md-icon
              >
            </slide-y-down-transition>
          </md-field>
          <md-field
            class="md-form-group"
            slot="inputs"
            :class="[
              { 'md-valid': !errors.has('password') && touched.password },
              { 'md-error': errors.has('password') }
            ]"
          >
            <md-icon>lock_outline</md-icon>
            <label>{{ $t("Mot de passe") }}</label>
            <md-input
              name="password"
              data-vv-name="password"
              v-model="password"
              required
              v-validate="'required|min:8|verify_password'"
              type="password"
            ></md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="errors.has('password')"
                >close</md-icon
              >
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon
                class="success"
                v-show="!errors.has('password') && touched.password"
                >done</md-icon
              >
            </slide-y-down-transition>
          </md-field>
          <md-field
            class="md-form-group"
            :class="[
              {
                'md-valid':
                  !errors.has('passwordConfirmation') &&
                  touched.passwordConfirmation
              },
              { 'md-error': errors.has('passwordConfirmation') }
            ]"
          >
            <md-icon>lock_outline</md-icon>
            <label>{{ $t("Confirmer le mot de passe") }}</label>
            <md-input
              name="passwordConfirmation"
              data-vv-name="passwordConfirmation"
              v-model="passwordConfirmation"
              v-validate="{ required: true, is: password }"
              type="password"
            />
            <slide-y-down-transition>
              <md-icon
                class="error"
                v-show="errors.has('passwordConfirmation')"
              >
                close
              </md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon
                class="success"
                v-show="
                  !errors.has('passwordConfirmation') &&
                    touched.passwordConfirmation
                "
              >
                done
              </md-icon>
            </slide-y-down-transition>
          </md-field>
          <p
            v-if="errors.has('password') || errors.has('passwordConfirmation')"
            class="text-danger small"
            style="margin: 0 0 5px 0"
          >
            {{
              $t(errors.first("password")) ||
                $t(errors.first("passwordConfirmation"))
            }}
          </p>
          <md-switch v-model="newsletter">
            {{ $t("Inscrivez-vous à notre liste d'envoi") }}
          </md-switch>

          <md-button
            class="md-primary"
            :style="errorMsg ? '' : 'margin-bottom: 30px'"
            @click="signup"
          >
            {{ $t("Commencez") }}
          </md-button>

          <p v-if="errorMsg" class="text-danger" style="margin-bottom: 30px">
            {{ errorMsg }}
          </p>
        </div>
        <div class="md-layout-item md-size-30 md-small-hide" />
      </div>
    </div>

    <FooterBlack_fr />
  </div>
</template>
<script>
import FooterBlack_fr from "./Landing/Layout/FooterBlack_fr.vue";
import NavbarBlack_fr from "./Landing/Layout/NavbarBlack_fr.vue";
import { SlideYDownTransition } from "vue2-transitions";
import { router } from "@/main";

export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {
    FooterBlack_fr,
    NavbarBlack_fr,
    SlideYDownTransition
  },
  name: "signup_fr",
  bodyClass: "index-page",
  props: {
    logoImg: {
      type: String,
      default: "./img/logo-inverted.png"
    },
    img: {
      type: String,
      default: "./img/default-avatar.png"
    }
  },
  data() {
    return {
      firstname: null,
      lastname: null,
      email: null,
      newsletter: true,
      password: null,
      passwordConfirmation: null,
      errorMsg: "",
      userlang: "fr",
      touched: {
        firstname: false,
        lastname: false,
        email: false,
        password: false,
        passwordConfirmation: false
      }
    };
  },
  computed: {
    setHeaderBgImage() {
      return {
        backgroundImage: `url(./img/background2x2.jpg)`
      };
    },
    setContactUsBgImage() {
      return {
        backgroundImage: `url(./img/bg-contactus.jpg)`
      };
    }
  },
  watch: {
    firstname() {
      this.touched.firstname = true;
      this.errorMsg = "";
    },
    lastname() {
      this.touched.lastname = true;
      this.errorMsg = "";
    },
    email() {
      this.touched.email = true;
      this.errorMsg = "";
    },
    password() {
      this.touched.password = true;
      this.errorMsg = "";
    },
    passwordConfirmation() {
      this.touched.confirmPassword = true;
      this.errorMsg = "";
    }
  },
  methods: {
    async signup() {
      const isValid = await this.$validator.validateAll();
      if (!isValid) {
        return;
      }

      const response = await this.$store.dispatch("auth/signup", {
        firstname: this.firstname,
        lastname: this.lastname,
        newsletter: this.newsletter,
        email: this.email,
        password: this.password
      });

      if (response.status === "failure") {
        this.errorMsg = this.$t(response.error);
        return;
      }

      router.push(
        process.env.NODE_ENV === "development"
          ? "/login_fr"
          : "/sign-up?lang=fr"
      );
    }
  }
};
</script>
<style lang="scss">
.section-download {
  .md-button + .md-button {
    margin-left: 5px;
  }
}

.vertical-nav-active {
  display: block;
}

@media all and (min-width: 991px) {
  .btn-container {
    display: flex;
  }
}
@media all and (max-width: 768px) {
  .vertical-nav-active {
    display: none;
  }
}

.mb-0 {
  padding-bottom: 0 !important;
}

#morphing-cards {
  padding-top: 70px;
}

.cd-section {
  height: 100vh;
}
</style>
